<template>
  <div class="table-responsive">
    <table class="table table-hover">
      <thead>
      <tr>
        <th>{{'status' | translate}}</th>
        <th>{{'article_number' | translate}} - SKU</th>
        <th>{{'order_informations' | translate}}</th>
        <th>{{'amount' | translate}} </th>
        <th>{{'client' | translate}}</th>
        <th class="sortable" @click="sort()"><i :class="sortClass ? 'fa fa-sort-asc' : 'fa fa-sort-desc'"></i> {{'date' | translate}}</th>
        <th>{{'edit' | translate}} </th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(order, index) in orders">
        <td>
          <template v-for="stat in order.status">
            <span :class="stat.style"><i :class="stat.icon"></i></span><br/>
          </template>
        </td>
        <td>
          <ul class="list-unstyled">
            <template v-for="item in order.lines">
              <li v-if="typeof item.status !== 'undefined'"><span :class="item.status.style">{{item.erp_additions.article_number}}</span> -
                <a target="_blank" :href="`http://www.schuhe.de/schuh/s-cp${item.sku.split('-')[0]}.html`">{{item.sku}}</a>
              </li>
            </template>
          </ul>
        </td>
        <td>
          <template v-if="order.payment_method === 'warentrade'">
            <img class="img-responsive img-channel" src="static/img/warentrading.svg">
          </template>
          <template v-else>
            <img class="img-responsive img-channel" :src="`static/img/${order.sales_channel}.svg`">
          </template>
          {{'order' | translate}} #: {{order.ext_order_id}}<br/>
          {{'ext_order_id_addition' | translate}} #: {{order.ext_order_id_addition}}<br/>
          {{'qualibet_id' | translate}}: {{order.id}}<br>
        </td>
        <td>
          {{order.order_total | currency}}<br>
          <small class="text-muted">{{order.number_of_lines}} {{'items' | translate}}</small>
        </td>
        <td>
          <span v-if="order.customer !== null">
              {{order.customer.delivery_first_name}} {{order.customer.delivery_last_name}}
            <br><span v-if="validDeliveryCountries.includes(order.customer.delivery_country)"><img class="img-responsive img-channel" :src="`static/img/country_${order.customer.delivery_country}.svg`"></span>
          </span>
        </td>
        <td>
          {{order.order_date | orderDate}}<br>
          <small class="text-muted">{{order.order_date | orderDate(true)}}</small>
        </td>
        <td>
          <router-link :to="`/orders/${order.id}`"><b-btn class="btn btn-info btn-app"><i class="fa fa-edit"></i>{{'edit' | translate}}</b-btn></router-link>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  props: ['orders'],
  data () {
    return {
      sortClass: window.localStorage.getItem('sortType') ? window.localStorage.getItem('sortType') === 'asc' : false,
      validDeliveryCountries: ['DE', 'AT', 'FR', 'NL', 'UK', 'GB', 'BE', 'ES', 'IT']
    }
  },
  methods: {
    sort () {
      this.sortClass = !this.sortClass
      this.$emit('sort', this.sortClass ? 'asc' : 'desc')
    }
  },
  watch: {
    model () {
      this.orders = []
    },
    sortClass () {
    }
  }
}
</script>
<style>
  .sortable:hover {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/tools/Tables/OrderTableComponent.vue